module.exports = __webpack_public_path__ + "img/marker_selected.7ef9da22.svg";